import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { HttpUtilsService } from '../../../app/content/pages/components/_core/utils/http-utils.service';
import { base_url } from '../../global';

@Injectable()
export class UserService {
	API_URL:any=base_url;
	public xhr = null;
	public apiResponse: boolean = true;
	constructor(private http: HttpClient,private httpUtils: HttpUtilsService) {}

	public listuserrequests(params): Observable<any> {
		const headers = this.httpUtils.getHTTPHeaders();
		return this.http
			.post(this.API_URL + 'user-request/list' , params , {headers: headers}
            );
	}

	public viewrequests(id): Observable<any> {
		let formData = {
			user_id: id
		};
	  return this.http.post(this.API_URL+'user-request/view',formData);
	}

	public acceptrequest(formData): Observable<any> {
		const headers = this.httpUtils.getHTTPHeaders();
		return this.http.post(this.API_URL+'user-request/accept',
		formData, {headers: headers});
	}
	public viewuser(params): Observable<any> {
		this.showLoader(true);
		this.apiResponse = false;
		const headers = this.httpUtils.getHTTPHeaders();
		return new Observable(observer => {
		//  this.http.post(this.API_URL + 'user/list', params, {headers: headers})
		 this.xhr = this.http.post(this.API_URL + 'user/list', params, {headers: headers})
		 .subscribe(
			response => {
					
					observer.next(response);
					this.showLoader(false);
			} );
	});
}
public listInspectors(params): Observable<any> {
	this.showLoader(true);
	this.apiResponse = false;
	const headers = this.httpUtils.getHTTPHeaders();
	return new Observable(observer => {
	//  this.http.post(this.API_URL + 'user/list', params, {headers: headers})
	 this.xhr = this.http.post(this.API_URL + 'global-inspector/list', params, {headers: headers})
	 .subscribe(
		response => {
				
				observer.next(response);
				this.showLoader(false);
		} );
});
}
	public viewcompany(): Observable<any>{
		const headers = this.httpUtils.getHTTPHeaders();
		return this.http.post(this.API_URL + 'company/list', {
			page: 1,
			show_all: 1,
			search: ""
		} , {headers: headers});
	}
	public viewcompanies(id): Observable<any>{
		const headers = this.httpUtils.getHTTPHeaders();
		return this.http.post(this.API_URL + 'company/list', {
			page: 1,
			show_all: 1,
			company_type: id,
			search: ""
		} , {headers: headers});
	}
	/**
	 * Server-side company lookup for the AED company picker.
	 *
	 * Unlike viewcompanies() this never loads the whole company table: the API
	 * returns at most `limit` id/name/reseller_id rows for the typed term. Keep it
	 * off showLoader() so typing doesn't flash the full page loader.
	 */
	public companyTypeahead(companyType, searchTerm, limit = 50): Observable<any> {
		const headers = this.httpUtils.getHTTPHeaders();
		const query = 'q=' + encodeURIComponent(String(searchTerm))
			+ '&company_type=' + encodeURIComponent(String(companyType))
			+ '&limit=' + encodeURIComponent(String(limit));
		return this.http.get(this.API_URL + 'company/search?' + query, { headers: headers });
	}

	public selectcompany(id): Observable<any> {
		const headers = this.httpUtils.getHTTPHeaders();
		if(id == 0){
			return this.http.post(this.API_URL + 'user/list', {
				page: 1,
				search: "",
			} , {headers: headers});
		}else{
			return this.http.post(this.API_URL + 'user/list', {
				page: 1,
				search: "",
				company_id: id,
			} , {headers: headers});
		}
	}
	// public viewrole(): Observable<any>{
	// 	const headers = this.httpUtils.getHTTPHeaders();
	// 	return this.http.post(this.API_URL + 'master/user-role/list', '' , {headers: headers});
	// }
	public viewuserpermission(): Observable<any> {
		const headers = this.httpUtils.getHTTPHeaders();
		return this.http.post(this.API_URL + 'master/role-permission-chart', { }, {headers: headers});
	}
	public blockuser(id): Observable<any> {
		const headers = this.httpUtils.getHTTPHeaders();
		return this.http.post(this.API_URL + 'user/change-status',{
        user_id: id,
        status: 0,
}, {headers: headers});
	}
	public unblockuser(id): Observable<any> {
		const headers = this.httpUtils.getHTTPHeaders();
		return this.http.post(this.API_URL + 'user/change-status',{
        user_id: id,
        status: 1,
}, {headers: headers});
	}

	public emailStatusChange(id, status): Observable<any> {
		const headers = this.httpUtils.getHTTPHeaders();
		return this.http.post(this.API_URL + 'user/change-email-notify',{
        user_id: id,
        email_notify: status,
}, {headers: headers});
	}

	public adduser(formData): Observable<any> {
		const headers = this.httpUtils.getHTTPHeaders();
		return this.http.post(this.API_URL + 'user/add-update',formData, {headers: headers});
	}
	/**
	 * One login, several companies. These hit the admin API's user/companies
	 * endpoints, which share the user_companies table with the hub.
	 */
	public checkUserEmail(payload): Observable<any> {
		const headers = this.httpUtils.getHTTPHeaders();
		return this.http.post(this.API_URL + 'user/check-email', payload, {headers: headers});
	}
	public listUserCompanies(userId): Observable<any> {
		const headers = this.httpUtils.getHTTPHeaders();
		return this.http.post(this.API_URL + 'user/companies/list', {user_id: userId}, {headers: headers});
	}
	// Active AEDs at the chosen sites, grouped by site, for the AED Inspector
	// list on Add User (ticket 10395802837).
	public aedsForSites(companyId, siteIds): Observable<any> {
		const headers = this.httpUtils.getHTTPHeaders();
		return this.http.post(this.API_URL + 'user/site-access/aeds-for-sites', {company_id: companyId, site_ids: siteIds}, {headers: headers});
	}
	public addUserCompany(payload): Observable<any> {
		const headers = this.httpUtils.getHTTPHeaders();
		return this.http.post(this.API_URL + 'user/companies/add', payload, {headers: headers});
	}
	public updateUserCompany(payload): Observable<any> {
		const headers = this.httpUtils.getHTTPHeaders();
		return this.http.post(this.API_URL + 'user/companies/update', payload, {headers: headers});
	}
	public removeUserCompany(ucId): Observable<any> {
		const headers = this.httpUtils.getHTTPHeaders();
		return this.http.post(this.API_URL + 'user/companies/remove', {uc_id: ucId}, {headers: headers});
	}
	public viewusers(id): Observable<any> {
		let formData = {
			user_id: id
		};
	  return this.http.post(this.API_URL+'user/view',formData);
	}
	public deleteUser(formData): Observable<any> {
		const headers = this.httpUtils.getHTTPHeaders();
	  return this.http.post(this.API_URL+'user/delete',formData);
	}

	public rejectrequest(rejectformData): Observable<any> {
		const headers = this.httpUtils.getHTTPHeaders();
		return this.http.post(this.API_URL+'user-request/reject',
		rejectformData, {headers: headers});
	}
	public viewsites(params): Observable<any> {
		this.showLoader(true);
		this.apiResponse = false;
		const headers = this.httpUtils.getHTTPHeaders();
		return new Observable(observer => {
		 this.xhr = this.http.post(this.API_URL + 'site/list', params, {headers: headers})
		 .subscribe(
			response => {
					
					observer.next(response);
					this.showLoader(false);
			} );
	});
}

public viewsitesfordrop(id) {
	const headers =this.httpUtils.getHTTPHeaders();
	return this.http.post(this.API_URL+'site/list',
	{company_id: id,'show_all':1},
	{headers:headers})
}

	public addSites(formData): Observable<any> {
		const headers = this.httpUtils.getHTTPHeaders();
		return this.http.post(this.API_URL + 'site/add',formData, {headers: headers});
	}
	public editSites(formData): Observable<any> {
		const headers = this.httpUtils.getHTTPHeaders();
		return this.http.post(this.API_URL + 'site/update',formData, {headers: headers});
	}
	public deleteSite(formData): Observable<any> {
		const headers = this.httpUtils.getHTTPHeaders();
	  return this.http.post(this.API_URL+'site/delete',formData)
	}
	public bulkUpdateSitePulsePoint(data): Observable<any> {
		const headers = this.httpUtils.getHTTPHeaders();
		return this.http.post(this.API_URL + 'site/bulk-update-pulsepoint', data, { headers: headers });
	}
	public syncSitePulsePointFromCompany(data): Observable<any> {
		const headers = this.httpUtils.getHTTPHeaders();
		return this.http.post(this.API_URL + 'site/sync-pulsepoint-from-company', data, { headers: headers });
	}
	public deleteResponder(formData): Observable<any> {
		const headers = this.httpUtils.getHTTPHeaders();
	  return this.http.post(this.API_URL+'responder/delete',formData)
	}
	public cancelRequest() {
		       if (this.xhr && !this.xhr.closed) {
		           this.xhr.unsubscribe();
		        }
				}
	showLoader(showLoader: boolean) {
					// document.getElementById('loading').style.display = showLoader ? 'block' : 'none';
			}
			public generateRx(path): Observable<any> {
				const headers = this.httpUtils.getHTTPHeaders();
				return this.http.get(path, {headers: headers});
			}

			public getPdf(path) {
        this.showLoader(true);
        this.apiResponse = false;
        return new Observable(observer => {
            const request = this.http.get(path, { headers: this.httpUtils.getHTTPHeaders(), responseType: 'blob', observe: 'response' })
                .subscribe(
                    repsonse => {
                        this.showLoader(false);
                        observer.next(repsonse);
                    },
                    error => {
                        var returnError:any;
                        var blob = new Blob([error.error], { type: 'application/json' ,endings:'native'});
                        
                        const reader = new FileReader();

                        // This fires after the blob has been read/loaded.
                        reader.addEventListener('loadend', (e) => {
                            returnError = e.srcElement['result'] || false;
                            if (returnError) {
                                returnError = JSON.parse(returnError);
                            }

                            observer.error(returnError);

                            this.showLoader(false);
                            if (returnError) {
															return returnError.message
                               // this.showError(returnError.message);
                            } else {
                               // this.showError('Unknown error occured.');
                            }
                        });

                        // Start reading the blob as text.
                        reader.readAsText(blob);
                    }
                );
        });
		}
		
		public viewaddInspectors(params): Observable<any> {
			this.showLoader(true);
			this.apiResponse = false;
			const headers = this.httpUtils.getHTTPHeaders();
			return new Observable(observer => {
			 this.xhr = this.http.post(this.API_URL + 'aed/add-aed-inspector-dependency', params, {headers: headers})
			 .subscribe(
				response => {
						
						observer.next(response);
						this.showLoader(false);
				} );
		});
	}

	public searchCompanies(companyType: number, searchTerm: string, page: number = 1, limit: number = 20): Observable<any> {
		console.log('searchCompanies called with:', { companyType, searchTerm, page, limit });
		this.showLoader(true);
		this.apiResponse = false;
		const headers = this.httpUtils.getHTTPHeaders();
		const params = {
			company_type: companyType,
			search: searchTerm,
			page: page,
			limit: limit,
			show_all: 0
		};
		
		console.log('API URL:', this.API_URL + 'company/list');
		console.log('Request params:', params);
		
		return new Observable(observer => {
			this.xhr = this.http.post(this.API_URL + 'company/list', params, {headers: headers})
			.subscribe(
				response => {
					console.log('API response received:', response);
					observer.next(response);
					this.showLoader(false);
				},
				error => {
					console.error('API error:', error);
					observer.error(error);
					this.showLoader(false);
				}
			);
		});
	}
}

